module.exports = __webpack_public_path__ + "static/media/Y1_GLOSS.265639fc.png";